import ModalHeader from '@modules/common/components/Modal/ModalHeader';
import { PermissionsTable } from '@modules/users/components/UnderstandUserRolesButton/PermissionsTable';
import { Box, DialogContent, Divider } from '@mui/material';

export const PermissionsModal = () => {
  return (
    <>
      <ModalHeader title="User Permissions" />
      <Divider light />
      <DialogContent>
        <Box mb={1}>
          <PermissionsTable />
        </Box>
      </DialogContent>
    </>
  );
};
